<template>
  <nav
    v-if="effectiveItems.length > 0"
    aria-label="breadcrumb"
    class="tw-min-w-0"
  >
    <ol class="tw-flex tw-items-center tw-gap-2 tw-m-0 tw-p-0 tw-min-w-0">
      <li
        v-for="(item, index) in effectiveItems"
        :key="index"
        class="tw-flex tw-items-center tw-gap-2 tw-min-w-0"
      >
        <a
          v-if="item.renderAsLink"
          :ref="(el) => setItemRef(el, index)"
          :href="item.url"
          class="
            tw-font-sans
            tw-text-xs
            tw-leading-[1.4]
            tw-text-sf-primary
            tw-no-underline
            hover:tw-underline
            tw-truncate tw-min-w-0
          "
        >
          {{ item.label }}
        </a>
        <span
          v-else
          :ref="(el) => setItemRef(el, index)"
          class="
            tw-font-sans
            tw-text-xs
            tw-font-normal
            tw-leading-[1.4]
            tw-text-sf-slate-dark-1
            tw-truncate
            tw-min-w-0
          "
          :aria-current="
            index === effectiveItems.length - 1 ? 'page' : undefined
          "
        >
          {{ item.label }}
        </span>
        <i
          v-if="index < effectiveItems.length - 1"
          class="
            fa fa-chevron-right
            tw-text-[10px] tw-text-slate-500 tw-shrink-0
          "
          aria-hidden="true"
        ></i>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import useListTruncationTooltips from './use-list-truncation-tooltips'
import type { BreadcrumbItem } from './types'

type Props = {
  items: BreadcrumbItem[]
  convertLastToText?: boolean
}

const { items, convertLastToText = true } = defineProps<Props>()

type EffectiveItem = BreadcrumbItem & {
  renderAsLink: boolean
}

const effectiveItems = computed<EffectiveItem[]>(() => {
  return items.map((item, index) => {
    const isLastItem = index === items.length - 1
    const renderAsLink = Boolean(item.url && !(isLastItem && convertLastToText))

    return {
      ...item,
      renderAsLink,
    }
  })
})

const { setItemRef } = useListTruncationTooltips(() =>
  effectiveItems.value.map((item) => item.label)
)
</script>
